import React, { useState, useEffect, Fragment } from "react";
import { Typography, Switch, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  switchLabel: {
    marginTop: 20,
    textAlign: "center",
  },
  boxSwitch: {
    display: "flex",
    justifyContent: "space-around",
  },
}));

const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState({
    presence: false,
    tri_verre: false,
    tri_papier: false,
    tri_emballages: false,
    tri_compost: false,
  });

  useEffect(() => {
    // Quand le composant se charge, autorise à passer à la suite
    props.setAuthorization(true);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local
    setValue({ ...value, [event.target.name]: event.target.checked });
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.checked;
    props.setResult(newResult);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        J'indique la présence ou le manque, la propreté ...
      </Typography>
      {/* Première ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Poubelles
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="presence"
          checked={value.presence}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      {/* Deuxième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Tri du verre
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="tri_verre"
          checked={value.tri_verre}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      {/* Troisième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Tri du papier
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="tri_papier"
          checked={value.tri_papier}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      {/* Quatrième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Compost
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="tri_compost"
          checked={value.tri_compost}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      {/* Cinquième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Emballages
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="tri_emballages"
          checked={value.tri_emballages}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
    </Fragment>
  );
};

export default Step1;
